// @ts-nocheck
// @ts-nocheck

import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Accordion from "@insite/mobius/Accordion";
import Button from "@insite/mobius/Button";
import CheckboxGroup from "@insite/mobius/CheckboxGroup";
import GridContainer from "@insite/mobius/GridContainer";
import Icon from "@insite/mobius/Icon";
import Search from "@insite/mobius/Icons/Search";
import { GridItem, TextArea } from "@insite/mobius/index";
import Popover from "@insite/mobius/Popover";
import TextField from "@insite/mobius/TextField/TextField";
import Typography from "@insite/mobius/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import ChevronDown from "@store/Library/Components/Icons/ChevronDown";
import CheckboxModalPicker from "@store/Library/Components/Reporting/ModalPicker/CheckboxModalPicker";
import useItem from "@store/Library/Widgets/ItemPicker/useItem";

import React, { useEffect, useRef, useState } from "react";
import styled, { css } from "styled-components";

const GridItemPicker = styled(GridItem)`
    && {
        display: block;
        max-width: 400px !important;
    }
`;

const ItemListDropdown = styled(Button)`
    && {
        display: block;
        width: 100%;
        padding: 0 10px;
        background-color: white;
        color: ${getColor("tertiary.main")};
        font-weight: 400;
        border: 1px solid rgb(156, 165, 178);
        min-height: 42px !important;
        text-align: left;
        font-size: 1rem;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
`;

const ItemListDropdownIcon = styled(Icon)`
    && {
        margin-left: auto;
    }
`;

const Badge = styled(Typography)`
    && {
        display: flex;
        padding: 3px 9px 3px 8px;
        margin-left: 0.75rem;
        margin-right: 0.75rem;
        letter-spacing: -0.025em;
        background-color: ${getColor("common.checkboxPickerBackground")};
        border-radius: 41%;
        color: ${getColor("secondary.main")};
        font-weight: 900;
        text-align: center;
        font-size: 0.75rem;
        align-items: center;
        justify-content: center;
    }
`;

const LabelItemPicker = styled(Typography)`
    && {
        font-size: 1rem;
        text-transform: none;
        color: ${getColor("tertiary.main")};
        min-height: 1.375rem;
        display: inline-block;
        width: 100%;
        font-weight: 700;
        line-height: 1.375;
        padding-bottom: 4px;
    }
`;

const PopoverItemPicker = styled(Popover)`
    && {
        max-height: 400px;
    }
`;

const ItemPickerWrapper = styled.div`
    padding: 0.5rem 1.25rem 1.25rem 1.25rem;
`;

const ItemPickerHeader = styled.div`
    display: flex;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin-top: 1rem;
    margin-bottom: 1rem;
`;

const SelectAllButton = styled(Button)`
    && {
        min-width: auto;
        min-height: auto;
        background-color: transparent !important;
        border: none !important;
        color: ${getColor("tertiary.main")};
        padding: 0;
        font-weight: 400;
        & span {
            font-size: 0.9rem !important;
        }
    }
`;
const SearchItemPicker = styled.div`
    padding-bottom: 0.5rem;
`;

const AccordionItemPicker = styled(Accordion)`
    && {
        display: block;
        dd[role="region"] {
            margin-top: 0.5rem;
            margin-left: -1.25rem;
            margin-right: -1.25rem;
            margin-bottom: 0.125rem;
            background-color: ${getColor("backgroundContrastLight")};
            padding: 0.75rem 2rem;
        }
        button {
            display: flex;
            align-items: center;
            margin-top: 0.75rem;
            margin-bottom: 0;
            line-height: 1.5;
            padding: 0.125rem 0;
            background-color: #fff;
            > div[data-id="checkbox"] {
                display: flex;
                align-items: center;
            }
            &::after {
                display: none;
            }
            &:focus {
                outline-color: transparent !important;
                outline: 0;
            }
        }
        .toggle {
            width: 18px;
            min-width: 18px;
            height: 18px;
        }
        .toggle svg {
            width: 15px;
            min-width: 15px;
            height: 15px;
        }
    }
`;

interface ItemData {
    item: ItemSKU[];
}

interface ItemSKU {
    id: string;
    name: string;
    sku: string;
}

const ItemData: ItemData = {
    item: [
        {
            id: "22100071",
            name: "Microblue Microfibre Damp",
            sku: "0004706",
        },
        {
            id: "09050021",
            name: "Citro Laundry Powder 18kg",
            sku: "0020072",
        },
        {
            id: "01250002",
            name: "Graffiti Scrub Towels",
            sku: "0030024",
        },
        {
            id: "27000003",
            name: "Tampons Naturelle 200/cs w",
            sku: "0030141",
        },
    ],
};

function getTotalItems() {
    const total = ItemData.item.reduce(total => {
        return total + 1;
    }, 0);

    return total;
}

function getAllItems() {
    const allItems = ItemData.item.map(item => item.id);
    return allItems;
}

function renderItem({ item, filter }) {
    return <CheckboxModalPicker key={item.id} itemText={`${item.id} (${item.sku}) ${item.name}`} filter={filter} />;
}

function ItemPicker() {
    const filter = useItem();

    const popover = useRef(typeof HTMLElement);
    // useEffect(() => popover.current && popover.current.focus());

    const popoverTrigger = (
        <ItemListDropdown data-test-selector="expandPOPicker">
            {translate("Item List")}
            {poSelectCount()}
            <ItemListDropdownIcon src={ChevronDown} />
        </ItemListDropdown>
    );

    function poSelectCount() {
        const total = filter.selectedItems.length;

        if (total > 0) {
            const amountBadge = <Badge variant="legend">{total}</Badge>;
            return amountBadge;
        }
    }

    return (
        <>
            <GridContainer>
                <GridItemPicker width={[12, 12, 12, 12, 12]}>
                    <LabelItemPicker variant="legend">{translate("Item Numbers")}</LabelItemPicker>
                    <PopoverItemPicker
                        contentBodyProps={{
                            as: "div",
                        }}
                        positionFunction={() => {
                            return {
                                position: "absolute",
                                left: 0,
                                width: "100%",
                            };
                        }}
                        hasChildPortal={true}
                        insideRefs={[popover]}
                        popoverTrigger={popoverTrigger}
                    >
                        <ItemPickerWrapper ref={popover}>
                            <ItemPickerHeader>
                                <Typography
                                    variant="h4"
                                    css={css`
                                        margin-bottom: 0;
                                        font-size: 1.25rem !important;
                                    `}
                                >
                                    {translate("Item Numbers")}
                                </Typography>
                                <SelectAllButton onClick={() => filter.toggleAllItems(getAllItems())}>
                                    {getTotalItems() === filter.selectedItems.length ? "Deselect All" : "Select All"}
                                </SelectAllButton>
                            </ItemPickerHeader>
                            <SearchItemPicker
                                css={css`
                                    & span {
                                        width: 36px;
                                        height: 36px;
                                    }
                                `}
                            >
                                <TextField
                                    iconProps={{ src: Search }}
                                    placeholder="Search Item"
                                    css={css`
                                        height: 40px !important;
                                        font-size: 0.9rem !important;
                                    `}
                                ></TextField>
                            </SearchItemPicker>
                            <CheckboxGroup>{ItemData.item.map(item => renderItem({ item, filter }))}</CheckboxGroup>
                        </ItemPickerWrapper>
                    </PopoverItemPicker>
                </GridItemPicker>
            </GridContainer>
        </>
    );
}

const widgetModel: WidgetModule = {
    component: ItemPicker,
    definition: {
        fieldDefinitions: [],
        group: "Common",
    },
};
export default widgetModel;
